export const deviceDashboardTypes = {
    FETCH_REQUEST: "SINGLE_DEVICE_FETCH_REQUEST",
    DEVICE_DATA_UPDATE_REQUEST: "SINGLE_DEVICE_DATA_UPDATE_REQUEST",
    FETCH_SUCCESS: "SINGLE_DEVICE_FETCH_SUCCESS",
    FETCH_FAILURE: "SINGLE_DEVICE_FETCH_FAILURE"
};

export const fetchRequest = (req) => ({
    type: deviceDashboardTypes.FETCH_REQUEST,
    payload: req
});

export const updateDeviceData = (resp) => ({
    type: deviceDashboardTypes.DEVICE_DATA_UPDATE_REQUEST,
    payload: resp
});

export const fetchSuccess = (resp) => ({
    type: deviceDashboardTypes.FETCH_SUCCESS,
    payload: resp
});

export const fetchFailure = (error) => ({
    type: deviceDashboardTypes.FETCH_FAILURE,
    payload: error
});